import { Download, Camera, Hash, Wallet } from "lucide-react";
import { Reveal } from "../lib/anim";

const STEPS = [
  {
    n: "01",
    icon: Download,
    title: "Install",
    desc: "Download GeoNetix from the Google Play Store and complete rapid KYC in under two minutes.",
  },
  {
    n: "02",
    icon: Camera,
    title: "Deploy Cam",
    desc: "Securely mount an approved GeoNetix Dashcam to your windshield and power it on.",
  },
  {
    n: "03",
    icon: Hash,
    title: "Enter Device Id",
    desc: "Copy your unique Device ID from the cam and paste it into the app to link the two.",
  },
  {
    n: "04",
    icon: Wallet,
    title: "Earn",
    desc: "Keep the app active while driving. Watch your INR balance tick up in real-time.",
  },
];

export const Onboarding = () => {
  return (
    <section
      id="how-it-works"
      data-testid="onboarding-section"
      className="relative py-24 md:py-32 bg-[#050d1a] border-y border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <p className="font-mono-gx text-xs uppercase tracking-[0.25em] text-[#00B4D8] mb-4">
            / How It Works
          </p>
          <h2 className="font-display font-black text-3xl md:text-5xl tracking-tight max-w-3xl leading-[1.1]">
            From download to payout in{" "}
            <span className="gx-text-gradient">four steps.</span>
          </h2>
        </Reveal>

        <div className="relative mt-16">
          {/* connector line */}
          <div className="hidden lg:block absolute top-8 left-0 right-0 h-px">
            <svg className="w-full h-2" preserveAspectRatio="none" viewBox="0 0 1000 2">
              <line
                x1="0"
                y1="1"
                x2="1000"
                y2="1"
                stroke="#00B4D8"
                strokeWidth="1.5"
                className="gx-dash"
                opacity="0.5"
              />
            </svg>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6">
            {STEPS.map((s, i) => {
              const Icon = s.icon;
              return (
                <Reveal key={s.n} delay={i * 0.1}>
                  <div className="group relative" data-testid={`step-${s.title.toLowerCase().replace(/\s+/g, "-")}`}>
                    <div className="relative z-10 mb-6 flex h-16 w-16 items-center justify-center rounded-2xl border border-white/10 bg-[#112240] transition-colors duration-300 group-hover:border-[#00B4D8] group-hover:bg-[#00B4D8]/10">
                      <Icon
                        size={24}
                        className="text-slate-300 transition-colors duration-300 group-hover:text-[#00B4D8]"
                      />
                    </div>
                    <div className="font-mono-gx text-sm text-[#4CAF50] mb-2">
                      Step {s.n}
                    </div>
                    <h3 className="font-display font-bold text-xl tracking-tight mb-3">
                      {s.title}
                    </h3>
                    <p className="text-sm text-slate-400 leading-relaxed">{s.desc}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
